import {
  isSessionLockedFlag,
  getLockedFlagValue,
  lockFlagValue
} from './sessionLockedFlags';

/**
 * Helper to get feature flags out of React components and other non-hook contexts.
 * Assumes that Split.io client is initialized and available on window.splitClient
 */
export const getFeatureFlag = (
  flagName: string,
  attributes?: SplitIO.Attributes
): boolean => {
  try {
    if (isSessionLockedFlag(flagName)) {
      const lockedValue = getLockedFlagValue(flagName);
      if (lockedValue !== null) {
        return lockedValue === 'on';
      }
    }

    const client = (window as any).splitClient;
    if (!client) {
      console.warn('Split client not available');
      return false;
    }

    const treatment = client.getTreatment(flagName, attributes);

    if (isSessionLockedFlag(flagName) && treatment) {
      lockFlagValue(flagName, treatment);
    }

    return treatment === 'on';
  } catch (error) {
    console.warn(`Could not retrieve feature flag: ${flagName}`, error);
    return false;
  }
};
